import * as React from "react"
import {Box, Table, TableBody, TableCell, TableRow} from "@mui/material";

import {capitalize, isEmpty} from "@ui-seeker/utils";
import SkuAttributesNoData from "./NoData";


export default function SkuAttributesTable({ show=false, attributes={} }) {
	if (attributes === null)
		return <></>

	return <Box display={show ? "flex" : "none"} flexWrap="wrap" gap={6}>
		{!!isEmpty(attributes) && <SkuAttributesNoData />}

		<Table>
			<TableBody>
				{ Object.entries(attributes).map(([key, value]) => {
					return <TableRow key={key}>
						<TableCell sx={{
							px: .5,
							py: 1,
							fontSize: "0.75rem",
							borderBottom: "1px solid #e6e6e6",
							backgroundColor: "#f4f4f4",
							fontWeight: "bold"
						}}>
							{capitalize(key).replace('_', ' ')}
						</TableCell>

						<TableCell sx={{
							px: .5,
							py: 1,
							fontSize: "0.75rem",
							borderBottom: "1px solid #e6e6e6"
						}}>
							{ typeof value === "boolean"
								? value ? 'Yes' : 'No'
								: (value || '-').toString()
							}
						</TableCell>
					</TableRow>
				}) }
			</TableBody>
		</Table>
	</Box>
}